<template>
  <div>
    <ul-nav  v-if="this.batch_id != null" :batch_id="batch_id"/>
    <div class="container-fluid" style="height: 1000px">
      <div
        class="row"
        v-if="this.table == 'ultralocal.ul_file_uploads'"
      >
        <h2 class="table-name" style="margin-bottom: 0">
          Ultralocal BFED Batch {{ this.batch_name }}
        </h2>
      </div>

      <div
        class="row"
        v-if="
          this.table == 'ultralocal.ul_file_uploads'
        "
      >
        <div :class="[this.table.replace('ultralocal.', '')]">
          <h4
            v-if="this.table == 'ultralocal.ul_file_uploads'"
            style="margin-bottom: 0"
          >
            Files included in this batch
          </h4>

          <p
            v-if="this.table == 'ultralocal.ul_file_uploads'"
            style="color: #bc243c; width: 75%; padding-top: 5px"
          >
            <b
              ><i>{{ pageDisclaimer }}</i></b
            >
        </p>          
          <div v-if="!searchError" class="search-options ">
            <div style="display: inline">
              <label for="pageSelect" style="margin-bottom: 15px"
                >Records per page</label
              >
              <select
                class="form-control record-number"
                :value="limit"
                id="pageSelect"
                v-on:change="changeLimit"
              >
                <option>25</option>
                <option>50</option>
                <option>100</option>
              </select>
            </div>
            <div style="display: inline">
              <label for="pageNum" style="display: inline">Page Number</label>
              <input
                type="number"
                :value="offset"
                min="1"
                v-on:change="changePage"
                class="form-control page-select"
                placeholder="Page #"
                id="pageNum"
              />
            </div>

            <div style="display: inline">
              <label for="orderBy" style="margin-bottom: 15px"
                >Sort Column</label
              >
              <select
                v-on:change="setOrderBy"
                v-model="orderBy"
                class="form-control orderBy"
                id="orderBy"
              >
                <option v-for="col in orderByFilters" :value="col.value">
                  {{ col.label }}
                </option>
              </select>
            </div>
            <div style="display: inline">
              <label for="sortDirection" style="margin-bottom: 15px"
                >Sort Direction</label
              >
              <select
                v-on:change="setSortDirection"
                v-model="sortDirection"
                class="form-control sortBy"
                id="sortDirection"
              >
                <option :value="''">None</option>
                <option :value="'desc'">Descending</option>
                <option :value="'asc'">Ascending</option>
              </select>
            </div>
            <div style="display:inline"><button class="btn btn-primary btn-hide" style="width: 200px" v-if="!showSearch && this.$route.params.table === 'ultralocal.ul_file_uploads'" @click="runUltralocalQA">
           Run Ultralocal QA On Batch
          </button></div>
            <div v-if="loading" class="fa-3x text-center">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
          </div>
          <div max-width="60px" style="max-height:350px;">
            <hot-table
              class="ulhandsontable_batches"
              :data="matchdata"
              :settings="settings"
              :columns="columnMetaData"
              ref="ulhot"
            >
            </hot-table>
          </div>
          <div style="padding-top:5px;"><router-link :to="`/file_upload?bfed_batch_id=${batch_id}${election? `&election_id=${election}`: ''}`">Upload additional files to this batch</router-link></div>
      </div>
      </div>
      <br>
      <div class="row text-center">
        <h3>Batch Overview</h3>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-2"><h4><b>Office Matching</b></h4>
          <div class="overview-graph"><span id="matching-done" class="done" :style="{ width: this.office_progress_pct +'%'}">{{office_progress}} </span><span id="matching-todo"></span></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-2 "><h4><b>Contest Data Complete</b></h4>
          <div class="overview-graph"><span id="contest-quality-done" class="done" :style="{ width: this.contest_progress_pct +'%'}">{{contest_progress}} </span><span id="contest-quality-todo"></span></div>
        </div>
        <div class="col-sm-2 "><h4><b>Candidate Data Complete</b></h4>
          <div class="overview-graph"><span id="candidate-quality-done" class="done":style="{ width: this.candidate_progress_pct +'%'}">{{candidate_progress}} </span><span id="candidate-quality-todo"></span></div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-2 "><h4><b>Gold Uploads</b></h4>
          <div class="overview-graph"><span id="gold-uploads-done" class="done"></span><span id="gold-uploads-todo"></span></div>
        </div>
        <div class="col-sm-2 "><h4><b>Page Creation</b></h4>
          <div class="overview-graph"><span id="page-creation-done" class="done":style="{ width: this.page_progress_pct +'%'}">{{page_progress}} </span><span id="page-creation-todo"></span></div>
        </div>
      </div>
    </div>
  </div>
</template>
 
 

<script>
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";
import "handsontable/dist/handsontable.full.css";
import VueQueryBuilder from "vue-query-builder";
import getFiltersForSearch from "../mixins/filtersForSearch.js";
import getOrderByFilters from "../mixins/getOrderByFilters.js";
import getColumnMetaData from "../mixins/columnMetaData.js";
//import getTablePermissions from "../mixins/getTablePermissions.js";
import getPageDisclaimer from "../mixins/pageDisclaimers.js";
import ULNavHeader from "../components/shared/ULNavHeader";



export default {
  name: "ULBatches",
  components: {
    HotTable,
    VueQueryBuilder,
    "ul-nav": ULNavHeader
  },
  mixins: [
    getOrderByFilters,
    getFiltersForSearch,
    getColumnMetaData,
    //getTablePermissions,
    getPageDisclaimer,
  ],
  data: function () {
    return {
      matchdata: [],
      columnMetaData: [],
      office_district_data: [],
      //permissions: this.getTablePermissions(this.$route.params.table),
      showSearch: false,
      activeQuery: false,
      showSearch2: false,
      activeQuery2: false,
      searchError: false,
      searchError2: false,
      showExpand: false,
      showSelectAll: false,
      depth: 1,
      limit: 25,
      offset: 1,
      pageDisclaimer: null,
      sortDirection: " ",
      loading: false,
      submitCreateClicked: false,
      workingOnSubmittedData: false,
      orderBy: null,
      orderByFilters: [],
      rules: [],
      table: this.$route.params.table,
      table_update: "ultralocal.ul_file_uploads",
      labels: {
        matchType: "Match Type",
        matchTypes: [
          { id: "all", label: "All of the filters" },
          { id: "any", label: "Any of the filters" },
        ],
        addRule: "Add Filter",
      },
      query: null,
      query2: null,
      table_hold: null,
      settingsTwo: {
        startRows: 1,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 500,
        comments: true,
      },
      batch_id:null,
      office_progress: 0,
      office_progress_pct: 0,
      contest_progress: 0,
      contest_progress_pct: 0,
      candidate_progress:0,
      candidate_progress_pct: 0,
      page_progress: 0,
      page_progress_pct: 0,
      batch_name: null,
      election: null,
      settings: {
        startRows: 1,
        rowHeaders:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? true
            : false,
        nestedRows:
          false,
        colHeaders:
          [],

        bindRowsWithHeaders: false,
        licenseKey: "non-commercial-and-evaluation",
        maxRows: 500,
        undo: true,
        comments: true,
        cells:
          this.$route.params.table == "ultralocal.ul_office_matching_selection"
            ? function (row, col) {
                var cellProperties = {};

                if (col != 8) {
                  cellProperties.readOnly = true;
                } else {
                  cellProperties.renderer = "checkbox";

                  //cellProperties.readOnly = this.checkReadOnly(row);
                }

                return cellProperties;
              }
            : null,

        afterChange: (changes) => {
          if (changes) {
              this.doChanges(changes);
          }
        },
        beforeUndo: async (action) => {
          let changes = action.changes;
          for await (const change of changes) {
            let cellMeta = this.$refs.ulhot.hotInstance.getCellMetaAtRow(
              change[0]
            );
            let colToChange = this.$refs.ulhot.hotInstance.colToProp(change[1]);
            let col = cellMeta.filter((obj) => {
              if (
                obj.__proto__.readOnly === false &&
                obj.__proto__.data === colToChange
              ) {
                return obj;
              }
            });
            if (col.length > 0 && change[2] != "" && change[2] != null) {
              // related table need to lookup value
              if (
                this.$refs.ulhot.hotInstance.getCellMeta(change[0], col[0].col)
                  .__proto__.relatedTable
              ) {
                let relatedTable = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.relatedTable;
                let colToUpdate = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.colToUpdate;
                let colToRender = this.$refs.ulhot.hotInstance.getCellMeta(
                  change[0],
                  col[0].col
                ).__proto__.colToRender;
               

                let response = await this.getRelatedData(
                  relatedTable,
                  change[2]
                );

                let responseField = colToRender.replace(`${colToUpdate}.`, "");
                let stringToRender = this.buildStringToRender(
                  response,
                  responseField
                );
                this.$refs.ulhot.hotInstance.setCellMeta(
                  change[0],
                  col[0].col,
                  "valueToRender",
                  stringToRender.slice(0, -1)
                );
                this.$refs.ulhot.hotInstance.render();
              }
            }
            if (col.length > 0 && (change[2] === "" || change[2] == null)) {
              this.$refs.ulhot.hotInstance.setCellMeta(
                change[0],
                col[0].col,
                "valueToRender",
                null
              );
              this.$refs.ulhot.hotInstance.render();
            }
          }
        },

        beforeKeyDown: (event) => {
          this.doBeforeKeyDown(event);
        },
       // beforePaste: (data, coords) => {
          //this.doBeforePaste(data, coords);
       // },

        afterPaste: async (data, coords) => {
          await this.doAfterPaste(data, coords);
        },
        beforeAutofill: async (start, end, data) => {
          await this.doBeforeAutofill(start, end, data);
        },
        afterOnCellMouseDown: async (e, coords, td) => {
          if (coords.row < 0){
            coords.row = 0;
          }
          let columnMetaData = this.$refs.ulhot.hotInstance.getCellMeta(coords.row, coords.col).__proto__;
          if (columnMetaData.renderer === 'downLoadButton'){
            this.downLoadDocument(e, coords, td);
            return;
          }

        },
      },
      
    };
  },

  methods: {
    async getFilteredData() {
    
      this.loading = true;

      let query = {};

      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy
        ? `${this.orderBy} ${this.sortDirection}`
        : null;

      query.isCountOnly = false;
      if (query.where && query.where.children) {
        this.activeQuery = true;
        // If user removes search criteria, null the WHERE clause.
        if (query.where.children.length === 0) {
          query.where = null;
          this.activeQuery = false;
        }
      }
      if(this.batch_id)
      {
        if (query.where === null)
        {
          query.where = {logicalOperator: "all",
            children: []
          }
        }
        query.where.children.push(
              // Build the query like the queryBuilder does it to pass to backend.
              {
                type: "query-builder-rule",
                query: {
                  rule: "named_bfed_batch",
                  selectedOperator: 'equal',
                  selectedOperand: "named_bfed_batch",
                  value: this.batch_id
                }
              }
            );
       }
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(query),
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
        if (response.success === true) {
          // Clear current table data.
          //set ui to expand

          this.matchdata = [];

          await this.$refs.ulhot.hotInstance.loadData(this.matchdata);

          let i = 0;
          await response.data.forEach((item) => {
            i++;
              this.matchdata.push(item);
            
          });
          this.searchError = false;
          await this.$refs.ulhot.hotInstance.loadData(this.matchdata);
        } else if (response.success === false) {
          this.searchError = true;
        }
        this.loading = false;
        this.showExpand = false;
        // if all the records have 1 suggestion we show select all
        this.showSelectAll = this.allEqual(
          this.$refs.ulhot.hotInstance.getSourceDataAtCol(
            this.$refs.ulhot.hotInstance.propToCol("number_of_suggestions")
          )
        );
      }
    },
    async doBeforeAutofill(start, end, data) {
      let rowCounter = -1;
     
      let colCounter = -1;
      for (let i = start.row; i <= end.row; i++) {
        rowCounter++;
        rowCounter = rowCounter > data.length - 1 ? 0 : rowCounter;

        for (let j = start.col; j <= end.col; j++) {
          colCounter++;
          colCounter = colCounter > data[0].length - 1 ? 0 : colCounter;
          if (
            this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
              .relatedTable
          ) {
            let relatedTable = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.relatedTable;
            let colToUpdate = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToUpdate;
            let colToRender = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToRender;
            if (isNaN(Number(data[rowCounter][colCounter]))) {
              continue;
            }
            let response = await this.getRelatedData(
              relatedTable,
              data[rowCounter][colCounter]
            );
            let responseField = colToRender.replace(`${colToUpdate}.`, "");
            let stringToRender = this.buildStringToRender(
              response,
              responseField
            );

            //colCounter++;
            if (
              this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
                .renderer === "relatedTableRenderer"
            ) {
              this.$refs.ulhot.hotInstance.setCellMeta(
                i,
                j,
                "valueToRender",
                stringToRender.slice(0, -1)
              );
              this.$refs.ulhot.hotInstance.render();
            }
          }
        }
      }
    },
  
    async refreshHoTData() {
      if (window.location.href.indexOf("where") > -1) {
        this.loading = true;
        let query = JSON.parse(
          JSON.stringify(
            decodeURIComponent(
              window.location.href
                ? window.location.href.split("?")[1]
                : window.location.search.slice(1)
            )
          )
        );
        this.query = JSON.parse(query).where;
        this.limit = JSON.parse(query).limit;
        this.offset = JSON.parse(query).offset;

        this.showSearch = true;
        

        await this.getFilteredData();

        this.loading = false;
      }
      // Else populate table with most recent updated records for table
      await this.getFilteredData();
    },
    //doBeforePaste(data, coords) {
      //  //  let rowCounter = coords[0].startRow - 1;
      //     let dataRowCounter = -1;
      //     let dataColCounter = -1;
      //     //  let colToRender;
      //     console.log("in before paste");
      //     for (let i = coords[0].startRow; i <= coords[0].endRow; i++) {
      //       //rowCounter++;
      //       dataColCounter = -1;
      //       dataRowCounter++;
      //       for (let j = coords[0].startCol; j <= coords[0].endCol; j++) {
      //         dataColCounter++;
      //         let cellMeta = this.$refs.ulhot.hotInstance.getCellMeta(i, j);
      //         console.log ('this is the before paste data')
      //         console.log(data[dataRowCounter][dataColCounter])
      //         if (
      //           isNaN(data[dataRowCounter][dataColCounter]) &&
      //           cellMeta.prop.includes(".id")
      //         ) {
      //           console.log("setting data null");
      //           return false;
      //         }
      //       }
      //     }
    //},

    async doAfterPaste(data, coords) {
      // if this related table field we need to get the related display information from the database

      //let rowCounter = coords[0].startRow - 1;
      let dataRowCounter = -1;
      let dataColCounter = -1;
      
      for (let i = coords[0].startRow; i <= coords[0].endRow; i++) {
        
        //rowCounter++;
        dataColCounter = -1;
        dataRowCounter++;
        for (let j = coords[0].startCol; j <= coords[0].endCol; j++) {
            dataColCounter++;
          if (
            this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
              .relatedTable
          ) {
            let relatedTable = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.relatedTable;
           
            let colToUpdate = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToUpdate;
           
            let colToRender = this.$refs.ulhot.hotInstance.getCellMeta(i, j)
              .__proto__.colToRender;

            //let response = await this.getRelatedData(relatedTable,Number(data[dataRowCounter][dataColCounter]));
            if (isNaN(Number(data[dataRowCounter][dataColCounter]))) {
              return;
            }
            let response = await this.getRelatedData(
              relatedTable,
              data[dataRowCounter][dataColCounter]
            );
            let responseField = colToRender.replace(`${colToUpdate}.`, "");
            let stringToRender = this.buildStringToRender(
              response,
              responseField
            );
            if (
              this.$refs.ulhot.hotInstance.getCellMeta(i, j).__proto__
                .renderer === "relatedTableRenderer"
            ) {
              this.$refs.ulhot.hotInstance.setCellMeta(
                i,
                j,
                "valueToRender",
                stringToRender.slice(0, -1)
              );
              this.$refs.ulhot.hotInstance.render();
            }
          }
        }
      }
    },
    async collapseRows() {
      this.$refs.ulhot.hotInstance
        .getPlugin("nestedRows")
        .collapsingUI.collapseAll();
      this.showExpand = true;
    },
    async expandAll() {
      this.$refs.ulhot.hotInstance
        .getPlugin("nestedRows")
        .collapsingUI.expandAll();
      this.showExpand = false;
      //console.log(this.$refs.ulhot.hotInstance.getSourceDataAtCol(0))
    },
    // here I am testing that all of the values in the array = 1
    // if they are, we show the Select All button
    allEqual(myArray) {
      if (myArray[0] && myArray[0] == 1) {
        return new Set(myArray).size === 1;
      } else {
        return false;
      }
    },
    //If selectall is clicked, loop through and set the select property to true
    async selectAll() {
      let array = this.$refs.ulhot.hotInstance.getData();

      for (let i = 0; i < array.length; i++) {
        this.$refs.ulhot.hotInstance.setDataAtCell(
          i,
          this.$refs.ulhot.hotInstance.propToCol("Select"),
          true
        );
      }
    },
    
    clearErrorValue(row, column) {
      const commentsPlugin = this.$refs.ulhot.hotInstance.getPlugin("comments");
      let comment = commentsPlugin.getCommentAtCell(row, column);
      if (comment) {
        commentsPlugin.removeCommentAtCell(row, column);
        this.$refs.ulhot.hotInstance.setCellMeta(row, column, "valid", true);
        this.$refs.ulhot.hotInstance.render();
      }
    },
    updateErrorValue(row, column, message) {
      const commentsPlugin = this.$refs.ulhot.hotInstance.getPlugin("comments");
      commentsPlugin.setCommentAtCell(row, column, message);
      this.$refs.ulhot.hotInstance.setCellMeta(row, column, "valid", false);
      this.$refs.ulhot.hotInstance.render();
    },

    
    doBeforeKeyDown(event) {
      let selected = this.$refs.ulhot.hotInstance.getSelected();
      
      let coords = {
        row: selected[0][0],
        col: selected[0][1],
      };

      if (event.key === "Delete" || event.key === "Backspace") {
        // if delete or backspace for a related table we want to loop trough all of them and delete the valueToRender
        for (let i = selected[0][0]; i <= selected[0][2]; i++) {
          for (let j = selected[0][1]; j <= selected[0][3]; j++) {
            this.$refs.ulhot.hotInstance.setCellMeta(
              i,
              j,
              "valueToRender",
              null
            );
            //this.$refs.hot.hotInstance.render();
          }
        }
        this.$refs.ulhot.hotInstance.render();
        return;
      } else 
      if (
        this.$refs.ulhot.hotInstance
          .getCellMeta(coords.row, coords.col)
          .prop.includes(".id")
      ) {
        if (!event.ctrlKey) {
          event.stopImmediatePropagation();
          //console.log("returning");
          return;
        }
      }
    },
    formatUpdatedValue(updatedValue, dataType) {
      if (
        (dataType === "integer" && updatedValue != null) ||
        (dataType === "numeric" && updatedValue != null)
      ) {
        updatedValue = updatedValue.toString().replace(/,/g, "");
      }
      if (typeof updatedValue === "string") {
        updatedValue = updatedValue.trim(); // Value of cell after change
        updatedValue = updatedValue.length === 0 ? null : updatedValue;
      }

      if (dataType === "ARRAY" && updatedValue) {
        updatedValue = `{${updatedValue}}`;
      }

      if (
        updatedValue === "true" ||
        updatedValue === "false" ||
        (!isNaN(updatedValue) &&
          updatedValue != null &&
          updatedValue.length > 0 &&
          dataType !== "character varying" &&
          dataType !== "text")
      ) {
        updatedValue = JSON.parse(updatedValue);
      }
      updatedValue = updatedValue == null ? null : updatedValue;
      return updatedValue;
    },

    getColumnNumber: (colIn) => {
      let changeFieldColumn;
      if (colIn.includes(".id")) {
        //indicates that we are working with a related table field - so we need to find the field we are renedering
        const rowMeta = this.$refs.ulhot.hotInstance.getCellMetaAtRow(0);

        changeFieldColumn = rowMeta.filter((obj) => {
          return (
            obj.__proto__.colToUpdate === colIn.substring(0, colIn.length - 3)
          );
        });
        changeFieldColumn = changeFieldColumn[0].col;
      } else {
        changeFieldColumn = this.$refs.ulhot.hotInstance.propToCol(colIn);
      }
      return changeFieldColumn;
    },
    async submitPayload(payload) {
      //console.log("in submit payload");
     // console.log(payload);
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "PATCH",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      return response;
    },
    updateParentSelect(row, select) {
      //console.log('selecting')
      for (let j = row; j >= 0; j--) {
        
        if (this.$refs.ulhot.hotInstance.getDataAtCell(j, 1) != null) {
          this.$refs.ulhot.hotInstance.setDataAtCell(
            j,
            this.$refs.ulhot.hotInstance.propToCol("Select"),
            select
          );
          break;
        }
      }
    },
    validateSelection(row) {
      //console.log('validating')
      // only one child record can be selected per parent
      let thisParent;

      for (let j = row; j >= 0; j--) {
        if (
          this.$refs.ulhot.hotInstance.getDataAtCell(
            j,
            this.$refs.ulhot.hotInstance.propToCol("contest")
          ) != null
        ) {
          thisParent = j;
          break;
        }
      }
       
      let k = thisParent + 1;
      
      while (
        this.$refs.ulhot.hotInstance.getDataAtCell(
          k,
          this.$refs.ulhot.hotInstance.propToCol("contest")
        ) == null && k <= this.$refs.ulhot.hotInstance
              .getPlugin('AutoRowSize').getLastVisibleRow() 
      ) {
        // console.log(`k is ${k}`);
        // console.log("this is the row");
        // console.log(row);
        // console.log(
        //   this.$refs.ulhot.hotInstance.getDataAtCell(
        //     k,
        //     this.$refs.ulhot.hotInstance.propToCol("Select")
        //   )
        // );

        if (
          k != row &&
          this.$refs.ulhot.hotInstance.getDataAtCell(
            k,
            this.$refs.ulhot.hotInstance.propToCol("Select")
          ) == true
        ) {
          return false;
        }
        k++;
      }
      return true;
    },

    doFormatUrl2() {
      //console.log("is this needed");
    },
    doFormatUrl() {
      const query = {};
      query.where = this.query;
      query.table = this.table;
      query.limit = this.limit;
      query.offset = this.offset;
      query.orderBy = this.orderBy
        ? `${this.orderBy} ${this.sortDirection}`
        : null;
      query.workflow = this.workflow ? this.workflow : null;

      let filterUrl;
      if (this.query === null) {
        filterUrl = `${window.location.href.split("?")[0]}`;
      } else {
        filterUrl = `${window.location.href.split("?")[0]}?${encodeURIComponent(
          JSON.stringify(query)
        )}`;
      }

      let textArea = document.createElement("textarea");
      textArea.value = filterUrl;
      document.body.appendChild(textArea);
      textArea.select();

      try {
        document.execCommand("copy");
        window.alert("Sharable URL copied to clipboard");
      } catch (err) {
        //empty
      }
      document.body.removeChild(textArea);
    },
    collapseAll() {
      this.collapseRows();
    },
    changePage() {
      this.offset = event.target.value;
      //console.log(this.offset);
      this.getFilteredData();
    },
    changePage2() {
      this.offset2 = event.target.value;

      this.getFilteredData2();
    },
    doSearch() {
      this.showSearch = false; // Hide search after click
      this.getFilteredData();
    },
    doSearch2() {
      this.showSearch2 = false; // Hide search after click
      this.getFilteredData2();
    },
    changeLimit() {
      this.limit = event.target.value;
      this.getFilteredData();
    },
    changeLimit2() {
      this.limit2 = event.target.value;
      this.getFilteredData2();
    },
    depthLevel() {
      this.depth = this.depth === 3 ? 1 : 3;
    },
    depthLevel2() {
      this.depth2 = this.depth2 === 3 ? 1 : 3;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    toggleSearch2() {
      this.showSearch2 = !this.showSearch2;
    },
    toggleExpand() {
      this.showExpand = !this.showExpand;
    },
    setOrderBy() {
      this.orderBy = event.target.value;
      this.getFilteredData();
    },
    setOrderBy2() {
      this.orderBy2 = event.target.value;
      this.getFilteredData2();
    },
    setSortDirection() {
      this.sortDirection = event.target.value;
      this.getFilteredData();
    },
    setSortDirection2() {
      this.sortDirection2 = event.target.value;
      this.getFilteredData2();
    },
    async runUltralocalQA(){
      /* this method calls api4 to start the ultralocal qa ecs task.
        if we are running on local host it will call the qa task that runs in dummy
        if we are not running on localhost it will call the prod qa task
        when the new prod qa task goes into effect, all that needs to be done here is to remove the comments on the container overrides after the else.
      */
      let container_overrides;
      let task_definition;
      if (process.env.VUE_APP_API4_DOMAIN === 'http://localhost:3000' || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org"){
        container_overrides =  {
          "name": "qa-app",
          "command": ['python', 'app.py', '--ultralocal', '--dummy', '--ul_batch='+this.batch_id]
       }
          task_definition = 'api4-qa-app-dev'
      }
        else {
         container_overrides = 
        {
           "name": "qa-app",
           "command": ['python', 'app.py', '--ultralocal', '--ul_batch='+this.batch_id]
        }
         task_definition = 'api4-qa-app'
        }
     
      let params = {
        cluster_name: 'default',
        task_definition: task_definition,
        launch_type: 'FARGATE',
        //,
      } 
      if (container_overrides) {  // Check if `someVariable` has data (truthy value)
          params.containerOverrides = container_overrides;  // Add the new_param to params
      }
       

      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/run_tasks/run_ecs_task`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(params)
      });

        response = await response.json(); // Convert response to JSON
      
        if(response.success === true ){
           alert('The QA process has been started. Check the ultralocal.ul_file_uploads edit page for completion time.');
        } else {
          alert('There was an issue starting the QA process.  Please try again or contact a member of the tech team.')
        }
      


    },
    
    async addRecord(dataObject) {
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;
      let payload = {
        data: [dataObject],
        table: "offices",
      };
      console.log(payload);
      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      response = await response.json();
      return response;
    },
    async getRelatedData(table, ids) {
      
      if (isNaN(Number(ids))) {
        return;
      }

      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud?table=${table}&ids=${ids}`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "GET",
          headers: headers,
          credentials: "include",
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json();
        //console.log("response is");
        //console.log(response);
        return response;
      }
    },
    buildStringToRender(response, responseField) {
      responseField = responseField.split(".");
       
      let buildStringToRender = "";
      let stringToRender = "";
      

      for (let i = 0; i < response.data.length; i++) {
        buildStringToRender = response.data[i];
         
        for (let i = 0; i < responseField.length; i++) {
          buildStringToRender = buildStringToRender[responseField[i]];
           
        }
        stringToRender += `${buildStringToRender},`;
      }
      return stringToRender;
    },
    async getBatchStats(batch_id)
    {
      let stats = [];
      let params = { "batch_id": batch_id};
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/import_engine/batch_stats`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(params),
        }
      );

      if (response.status == 403) {
        response = await response.json();
        alert(response.message);
        window.location.href = "/login";
      } else {
        response = await response.json(); // Convert response to JSON
        if (response.success === true) {
          // Clear current table data.
          //set ui to expand
          //console.log(response);
          let stats = response.data[0].batch_stats;
          let contest_stats = stats.contests[0];
          let candidate_stats = stats.candidates[0];
          let office_stats = stats.offices[0];
          let page_stats = stats.pages[0];
          
          this.contest_progress = contest_stats.matched_contests;
          this.contest_progress_pct = (contest_stats.matched_contests/contest_stats.total_contests) *100;
          this.candidate_progress = candidate_stats.matched_candidates;
          this.candidate_progress_pct = (candidate_stats.matched_candidates/candidate_stats.total_candidates) * 100;
          this.office_progress = office_stats.matched_offices;
          this.office_progress_pct = (office_stats.matched_offices/office_stats.total_offices) * 100;
          this.page_progress = page_stats.pages_created;
          this.page_progress_pct = (page_stats.pages_created/page_stats.total_pages)*100;
         
        } else if (response.success === false) {
          this.statsError = true;
        }
        
      }

    },
    async downLoadDocument(e, coords, td) {
      
      let file_to_download = this.$refs.ulhot.hotInstance.getDataAtCell(coords.row,coords.col)  
      file_to_download = file_to_download.replace('https://','')
      file_to_download  = file_to_download.replace('.s3.amazonaws.com','')

      let f_array = file_to_download.split('/')
      
      let bucket_name = f_array[0]
      f_array.shift()
      let key = f_array.join('/')
           
      let mime_type = key.slice(-3)
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/files/get_presigned_url_get`;

      let response1 = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify({
            filename: key,
            mimetype: mime_type,
            bucket_name: bucket_name,
          }),
        }
      );
       response1 = await response1.json();
       let tempLink = document.createElement('a');
       tempLink.setAttribute('target', '_blank');
       tempLink.href = response1.data.url ;
       tempLink.click();
      },
  },

  mounted: async function () {
    //console.log(Handsontable.version);
    // console.log(this.$route.params.table);
    if (window.location.href.indexOf("bfed_batch") > -1) {
       this.batch_id  = JSON.parse(
          JSON.stringify(decodeURIComponent(window.location.href ? window.location.href.split("?")[1] : window.location.search.slice(1)))
        );
          this.batch_id = this.batch_id.replace('bfed_batch_id=', '');
    } 
    
    await this.getBatchStats(this.batch_id);

    this.columnMetaData = [];
    await this.generateColumnMetaData("Edit", this.table);

     
    this.rules = await this.generateFiltersForSearch();

    
    this.orderByFilters = await this.getOrderByFilters(this.rules);
    await this.refreshHoTData();
    this.election = this.$refs.ulhot.hotInstance.getDataAtCell(0, this.$refs.ulhot.hotInstance.propToCol('election') )
    this.pageDisclaimer = await this.getPageDisclaimer(
      this.table.replace("ultralocal.", "")
    );
  },
};
Handsontable.renderers.registerRenderer(
  "relatedTableRenderer",
  function (hotInstance, td, row, column, prop, value, cellProperties) {
    //console.log('rendering')
    let cellMeta = hotInstance.getCellMeta(row, column);
    let valToRender;
    if (cellProperties.valid === false) {
      td.className = "htInvalid";
    }
    if (cellProperties.readOnly === true) {
      td.className = "htDimmed";
    }
    if (cellMeta.valueToRender === null || cellMeta.valueToRender) {
      valToRender = cellMeta.valueToRender;
    } else {
      valToRender = hotInstance.getDataAtRowProp(
        row,
        cellMeta.__proto__.colToRender
      );
    }

    if (valToRender !== null && typeof valToRender != "object") {
      td.innerHTML = valToRender;
    } else {
      td.innerHTML = value == null ? "" : value;
    }

    return td;
  }
);
</script>
<style scoped>
.page-select,
.record-number {
  width: 75px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.orderBy,
.sortBy {
  width: 120px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.frozenSelect {
  width: 70px;
  display: inline-block;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 12px;
}

.workflow {
  width: 160px;
}

.search-options label {
  font-size: 12px;
}

.search-options .form-control {
  height: 30px;
}

.btn {
  margin-top: 30px;
  margin-bottom: 20px;
}

.btn-default {
  margin-right: 10px;
}

.btn-hide {
  margin-right: 0px;
  margin-bottom: 10px;
  margin-top: 0px;
}

.btn-share,
.btn-search {
  margin-bottom: 2px;
  width: 125px;
}

.checkbox {
  margin-top: 0px;
}

h3 {
  margin-bottom: 20px;
}
label {
  padding-top: 5px;
}

.table-name {
  text-align: left;
}
.container-fluid {
  margin-right: 3%;
  margin-left: 5%;
  margin-bottom: 10%;
}
.show-search {
  margin-top: 0;
  margin-bottom: 0;
}
.badge-error {
  background-color: red;
  color: white;
}
.edit-add {
  color: #337ab7;
}
</style>
 <style>
.ulhandsontable {
  margin-left: -5px;
  margin-bottom: 20px;
}
.ulhandsontable_small {
  width: 90%;
  height: 800px;
  overflow: hidden;
}
.ulhandsontable .ht_nestingParent,
.ulhandsontable .ht_nestingParent ~ td {
  background: #073980;
  color: #fff;
  font-weight: lighter !important;
  font-style: normal !important;
}

.ulhandsontable .ht_nestingLevels ~ td {
  font-weight: bolder;
  padding-top: 1px;
  padding-bottom: 1px;
  padding-bottom: 1px;
}

.offices_for_matching {
  display: block;
  float: right;
  width: 48%;
  font-size: 0.85em;
 }
.districts_for_matching {
  display: block;
  float: right;
  width: 38%;
  font-size: 0.85em;
}
.ul_office_matching {
  float: left;
  width: 52%;
  font-size: 0.85em;
  
}
.ul_offices_creation_workflow {
  float: left;
  width: 60%;
  font-size: 0.85em;
   
}
.ul_success  {
  background: #cff8a5 !important;
}

.ulhandsontable_batches {
  min-height: 150px;
  max-height: 350px;
  overflow: auto;
}
.align-right {
  text-align: right;
}
.align-left{
  text-align: left;
}
.overview-graph {
  border: 1px solid #000;
  border-radius: 5px;
  max-width: 300px;
  height: 2em;
}
.overview-graph .done {
  background-color: rgb(51, 122, 183);
  height: 2em;
  display: inline-block;
  border-radius: 5px 0px 0px 5px;
  margin-right: 2px solid black;
  
}


</style>